var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sga-step-header"},[_c('h2',{staticClass:"sga-step-header__title"},[_vm._v(_vm._s(_vm.title))]),(_vm.description)?_c('p',{staticClass:"sga-step-header__description"},[_vm._v(_vm._s(_vm.description))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }